module.exports = __webpack_public_path__ + "web/img/webp.0ae4c828.png";